import { ValueObject } from './calculationComponents.helpers';

export interface calculationComponentProps {
  formElementHeading?: string;
  formElementName: string;
  formElementJson?: string;
}

export interface calculationComponentState {
  jsonFields: string;
  isValid: boolean;
  isTouched?: boolean;
}

export interface calculationComponentModel {
  columns: any;
  values: ValueObject[][];
  sum?: any;
  heading?: string;
}

export class calculationComponentModel2 {
  id: string;
  type: string;
  headerValue: string;
  headerDefinitions?: Header[];
  columnDefinitions: ColumnDefinitions;

  public static Create = (elementName: string, mainHeading: string, componentName: string): calculationComponentModel2 => {

    return {
      id: elementName,
      type: componentName,
      headerValue: mainHeading,
      headerDefinitions: [],
      columnDefinitions: {
        columnTypeGroups: [],
      },
    };
  }
}
export interface Header {
  id: Number;
  value: string;
}
export interface ColumnDefinitions {
  columnTypeGroups: ColumnTypeGroup[];
}

export interface ColumnTypeGroup {
  headerId?: number;
  headerValue?: string;
  isSum?: boolean;
  columnValues?: ColumnValue[];
  columnValuesSections?: ColumnValuesSection[]
}

export interface ColumnValuesSection {
  headerId?: number;
  headerValue?: string;
  columnValues: ColumnValue[];
}

export interface ColumnValue {
  headerValue?: string;
  headerId?: number;
  value: string;
  isSum?: boolean;
}